React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_bulk_actions_progress_done')

module.exports = class extends React.Component
  render: t.renderable ->
    { results, onDoneClick } = @props

    t.div ->
      t.p ->
        if results > 1
          t.format 'boards-visibility-updated', { resultCount: results }
        else
          t.format 'board-visibility-updated', { resultCount: results }

      t.div ->
        t.button
          class: 'primary full'
          onClick: onDoneClick
        , ->
          t.format 'done'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/progress-component/board-bulk-update-vis-done-component.coffee